import { IDropdownItem, IDropdownListSearch } from "../../../types/dropdownInterface";
import { SectionDropdown, SectionDropdownActionType } from "../../actionTypes/permissions/sectionDropdownActionTypes";

export const getSectionListDropdown = (payload: IDropdownListSearch): SectionDropdownActionType => ({
  type: SectionDropdown.GET_SECTION_DROPDOWN_LIST,
  payload,
});

export const setSectionListDropdown = (payload: Array<IDropdownItem>): SectionDropdownActionType => ({
  type: SectionDropdown.SET_SECTION_DROPDOWN_LIST,
  payload,
});

export const setSectionDropdownId = (payload: number): SectionDropdownActionType => ({
  type: SectionDropdown.SET_SECTION_DROPDOWN_ID,
  payload,
});